import { Text } from "theme-ui";
import { Alert, Button } from "@smerth/gatsby-theme-theme-ui";
import * as React from 'react';
export default {
  Text,
  Alert,
  Button,
  React
};